<template>
  <div class="new-main-page">
    <h1 class="new-main-header">
      <img
        :src="theme.current.headerImage"
        alt="AI Logo"
        class="header-image"
      />
    </h1>
    <div class="table-container">
      <button @click="exportCSV" class="export-button">Export CSV</button>
      <div class="filter-container">
        <select v-model="selectedColumn" class="filter-dropdown">
          <option value="">All Columns</option>
          <option value="id">User ID</option>
          <option value="email">Email</option>
          <option value="session">Session</option>
          <option value="demographics">Demographics</option>
          <option value="peerMentor">Peer Mentor</option>
        </select>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search..."
          class="search-input"
        />
      </div>
      <table class="data-table">
        <thead>
          <tr>
            <th>User ID</th>
            <th>Email</th>
            <th>Session</th>
            <th>Demographics?</th>
            <th>Peer Mentor?</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(user, index) in filteredUsers"
            :key="user.id"
            :class="{ highlight: index % 2 === 0 }"
          >
            <td>{{ user.id }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.session }}</td>
            <td>{{ user.demographics }}</td>
            <td>{{ user.peerMentor }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { useThemeStore } from "@/stores/theme";

export default {
  name: "DataPage",
  setup() {
    const theme = useThemeStore();
    return { theme };
  },
  data() {
    return {
      searchQuery: "",
      selectedColumn: "",
      users: [
        {
          id: "user_1",
          email: "user_1@example.com",
          session: "Reality",
          demographics: "Male",
          peerMentor: "name_1",
        },
        {
          id: "user_2",
          email: "user_2@example2.com",
          session: "Reality2",
          demographics: "Female",
          peerMentor: "name_2",
        },
        {
          id: "user_3",
          email: "user_3@example2.com",
          session: "Reality3",
          demographics: "Female",
          peerMentor: "name_3",
        },
      ],
    };
  },
  computed: {
    filteredUsers() {
      console.log(this.selectedColumn);
      return this.users.filter((user) => {
        if (this.selectedColumn) {
          return String(user[this.selectedColumn])
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        } else {
          return Object.keys(user).some((key) => {
            return String(user[key])
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase());
          });
        }
      });
    },
  },
  methods: {
    exportCSV() {
      const headers = [
        "User ID",
        "Email",
        "Session",
        "Demographics?",
        "Peer Mentor?",
      ];
      // const rows = this.users.map(user => [user.id, user.email, user.session, user.demographics, user.peerMentor]);
      const rows = this.filteredUsers.map((user) => [
        user.id,
        user.email,
        user.session,
        user.demographics,
        user.peerMentor,
      ]);

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += headers.join(",") + "\n";
      rows.forEach((row) => {
        csvContent += row.join(",") + "\n";
      });

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "users.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.new-main-page {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
  min-height: 100vh;
  min-height: -webkit-fill-available;
}

.new-main-page h1,
.new-main-page p,
.new-main-page form,
.new-main-page div {
  width: 100%;
  text-align: left;
}

.new-main-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px; /* Adjust as needed */
  padding: 0;
  margin: 0;
  margin-bottom: 25px;
}

.table-container {
  background-color: #ffffffb2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;
  margin: 0 auto;
  max-width: 80%;
  width: 100%;
  max-height: 50%; /* Set a maximum height for the table container */
  overflow-y: auto; /* Enable vertical scrolling */
  margin-left: 20px;
  border-radius: 10px; /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow for better visibility */
  padding: 2%;
}

.search-input {
  padding: 8px;
  font-size: 16px;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: none;
}

.data-table th,
.data-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  border: none;
}

.data-table th {
  background-color: transparent;
}

.highlight {
  background-color: #d3eaff;
}

.export-button {
  margin-bottom: 5px;
  text-align: left;
  width: 15%;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: bold;
  background-color: transparent;
  color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.export-button:hover {
  background-color: #0056b3;
}

.filter-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}

.filter-dropdown {
  margin-right: 10px;
  padding: 8px;
  font-size: 16px;
}
@media (max-width: 768px) {
  .table-container {
    background-color: #e9e5d6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    margin: 0 auto;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
    margin-left: 20px;
    border-radius: 10px;
    box-shadow: none;
    padding: 5%;
  }
  .data-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    border: none;
  }
  .new-main-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #e9e5d6;
  }
  .new-main-header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5%;
    background-color: #e9e5d6;
    padding: 5;
    margin: 5;
    margin-top: 20px;
  }
  .new-main-page h1,
  .new-main-page p,
  .new-main-page form,
  .new-main-page div {
    width: 100vw;
    text-align: left;
  }
  .header {
    height: auto;
  }
  .header-image {
    width: 100%;
    height: auto;
  }
}
</style>
